/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Chat_Note_StudentInputs */

const en_us2_coaching_chat_note_student = /** @type {(inputs: Coaching_Chat_Note_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only you and the group's trainers read this conversation. Your conversations with the AI stay yours alone.`)
};

const pt_br2_coaching_chat_note_student = /** @type {(inputs: Coaching_Chat_Note_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só você e o personal da turma leem esta conversa. Suas conversas com a IA continuam só suas.`)
};

const pt_pt2_coaching_chat_note_student = /** @type {(inputs: Coaching_Chat_Note_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só você e o personal da turma leem esta conversa. Suas conversas com a IA continuam só suas.`)
};

/** @type {(inputs: Coaching_Chat_Note_StudentInputs) => LocalizedString} */
const es_419_coaching_chat_note_student = en_us2_coaching_chat_note_student;

/** @type {(inputs: Coaching_Chat_Note_StudentInputs) => LocalizedString} */
const fr_fr2_coaching_chat_note_student = en_us2_coaching_chat_note_student;

/** @type {(inputs: Coaching_Chat_Note_StudentInputs) => LocalizedString} */
const de_de2_coaching_chat_note_student = en_us2_coaching_chat_note_student;

/** @type {(inputs: Coaching_Chat_Note_StudentInputs) => LocalizedString} */
const it_it2_coaching_chat_note_student = en_us2_coaching_chat_note_student;

/**
* | output |
* | --- |
* | "Only you and the group's trainers read this conversation. Your conversations with the AI stay yours alone." |
*
* @param {Coaching_Chat_Note_StudentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_chat_note_student = /** @type {((inputs?: Coaching_Chat_Note_StudentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Chat_Note_StudentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_chat_note_student(inputs)
	if (locale === "es-419") return es_419_coaching_chat_note_student(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_chat_note_student(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_chat_note_student(inputs)
	if (locale === "de-DE") return de_de2_coaching_chat_note_student(inputs)
	if (locale === "it-IT") return it_it2_coaching_chat_note_student(inputs)
	return en_us2_coaching_chat_note_student(inputs)
});
export { coaching_chat_note_student as "coaching.chat_note_student" }